<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 教室考勤 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input placeholder="科任老师" :readonly="true" v-model="form.ondutyTeacherLabel" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"  :disabled="form.adminSign" @click="findUser()"></el-button>
                        </el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-folder-add" @click="importClassRoomTime()">导入</el-button>
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                v-loading="loading"
                :element-loading-text="loadingText"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"  :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="策略名称" width="100"></el-table-column>
                <el-table-column prop="ondutyTeacherName" label="科任老师" width="150"></el-table-column>
                <el-table-column prop="attendaceGroupName" label="绑定考勤组" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attendaceGroupName != null 
                                && scope.row.attendaceGroupName!=''">
                            {{scope.row.attendaceGroupName}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="commonName" label="所属年级" width="100"></el-table-column>
                <el-table-column prop="className" label="所属班级" width="100"></el-table-column>
                <el-table-column prop="deptControllerName" label="班主任"  width="80" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="classHoursName" label="上课时间段"  :show-overflow-tooltip="true" width="300"></el-table-column>              
                <el-table-column prop="noticeClassTeacher" label="通知班主任(班级考勤)" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.noticeClassTeacher == 1">
                            开启
                        </div>
                        <div v-else>
                           <span style="color: red;">关闭</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="hostelNoticeClassTeacher" label="通知班主任(宿舍考勤)" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.hostelNoticeClassTeacher == 1">
                            开启
                        </div>
                        <div v-else>
                           <span style="color: red;">关闭</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="通知家长(教职点评)" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.dpNoticeParent == 1">
                            开启
                        </div>
                        <div v-else>
                           <span style="color: red;">关闭</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="synchroStatus" label="状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.synchroStatus == 0">
                            <span style="color: red;">设备同步失败</span>
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 1">
                            等待与设备同步
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 2 
                            || scope.row.synchroStatus == null">
                            已同步到设备
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 3">
                            <span style="color: red;">正在删除</span>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceNo" label="人脸设备编号" width="130"></el-table-column>
                <el-table-column prop="hkDeviceNo" label="录播设备编号" width="130"></el-table-column>
                <el-table-column prop="remark" label="备注" width="150" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="125">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleSetHeadTeacher"
                                    icon="el-icon-circle-check">设置班主任</el-dropdown-item>
                                <el-dropdown-item command="handleSetIndex"
                                    icon="el-icon-circle-check">修改指标</el-dropdown-item>
                                <el-dropdown-item command="handleConfigGroup"
                                    icon="el-icon-circle-check">配置分组</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
        <!-- 修改指标 -->
        <div v-if="indexMainVisible">
            <indexMain ref="indexMain"></indexMain>
        </div>
        <!-- 配置小组 -->
        <div v-if="groupListVisible">
            <groupList ref="groupList"></groupList>
        </div>
        <!--导入 -->
        <div v-if="importClassRoomTimeVisible">
            <importClassRoomTime ref="importClassRoomTime"></importClassRoomTime>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import indexMain from './indexMain.vue';
    import groupList from './group/list.vue';
    import importClassRoomTime from './ImportClassRoomTime.vue';

    export default {
        name:"ClassroomTime",
        data(){
            return{
                addVisible:false,
                updateVisible:false,
                transferVisible:false,
                indexMainVisible:false,
                groupListVisible:false,
                importClassRoomTimeVisible:false,
                loading:false,
                loadingText:"",
                menuName:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    ondutyTeacherId:"",
                    ondutyTeacherLabel:"",
                    deptId:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                currUserId:"",
                operaType:1  // 1-设置班主任，2-设置科任老师
            }
        },
        components: {
            add,update,userTransfer,indexMain,groupList,importClassRoomTime
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){ 
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listSetClassroomTimeUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    ondutyTeacherId:this.form.ondutyTeacherId,
                    deptId:this.form.deptId
                };
                
                this.loading=true;
                this.loadingText="数据加载中...";
                this.apiPost(url,data).then((res) => {
                    // console.log("班级策略列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            },
            selectable(row){
                return true;
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            importClassRoomTime(){
                // 触发导入界面
                this.importClassRoomTimeVisible = true;
                this.$nextTick(() => {
                    this.$refs['importClassRoomTime'].init();
                })    
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.setClassroomTimeRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            // 更多操作触发
            handleCommand(command, row) {
                switch (command) {
                    case "handleSetHeadTeacher":
                        this.setHeadTeacher(row)
                        break;
                    case "handleSetIndex":
                        this.updateEvaluateIndex(row)
                        break;
                    case "handleConfigGroup":
                        this.configGroup(row);
                        break;
                    default:
                        break;
                }
            },
            // 设置班主任
            setHeadTeacher(row){
                this.form.id=row.classId
                this.transferVisible=true
                this.operaType = 1
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(row.commonId)){
                        let val=new Array()
                        val.push(row.commonId)
                        this.$refs['userTransfer'].init(2,val,1,this.form.deptId)
                    }else{
                        this.$refs['userTransfer'].init(2,null,1,this.form.deptId)
                    }
                })
            },
            // 查询科任教师
            findUser(){
                this.transferVisible=true
                this.operaType =2
                this.$nextTick(() => {
                    this.$refs['userTransfer'].init(2,null,1,this.form.deptId)
                })
            },
            setUser(key,label){
                if(this.operaType == 1){
                    let data = {
                        id:this.form.id,
                        deptController:key
                    };
                    let url  = this.deptSetClassMasterUrl;
                    this.loading=true;
                    this.apiPost(url,data).then((res) => {
                        if(res.status == 200){
                            this.getData()
                        }else{
                            this.$commonFn.showTip(res.message,3)
                        }
                        this.loading=false
                    },(err)=>{
                        console.log(err)
                        this.loading=false
                    });
                }else{
                    this.form.ondutyTeacherId = key
                    this.form.ondutyTeacherLabel = label
                }
            },
            // 修改评价指标
            updateEvaluateIndex(data){
                this.indexMainVisible=true;
                this.$nextTick(() => {
                    this.$refs['indexMain'].init(this.currUserId,data.classId);
                })

            },
            // 配置小组
            configGroup(data){
                this.groupListVisible=true;
                this.$nextTick(() => {
                    this.$refs['groupList'].init(this.currUserId,data.classId);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/ClassroomTime.vue